import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import SummaryDetail from './export-component/SummaryDetail.vue';
import GuangFa from './export-component/GuangFa.vue';
import DelayOrder from './export-component/DelayOrder.vue';
import BindCard from './export-component/BindCard.vue';
import StoreInfo from './export-component/StoreInfo.vue';
import MerchandiseInfo from './export-component/MerchandiseInfo.vue';
import CouponInfo from './export-component/CouponInfo.vue';
import ExportByNumOrMoney from './export-component/ExportByNumOrMoney.vue';
import TrackingPointsData from './export-component/TrackingPointsData.vue';
import OrderTotalData from './export-component/OrderTotalData.vue';
import OrderReport from './export-component/OrderReport.vue';
import QixinOrder from './export-component/QixinOrder.vue';
import HailiOrder from './export-component/HailiOrder.vue';
import SummaryBottom from './export-component/SummaryBottom.vue';
import BaoPinData from './export-component/BaoPinData.vue';
import { useStore } from '@/store'

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderData',
  setup(__props) {

const store = useStore()
const userGroups = store.state.user.userInfo.group_id.split(',')
const user_id = Number(store.state.user.userInfo.id)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userGroups).includes('1')  || _unref(userGroups).includes('21'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SummaryDetail)
        ]))
      : _createCommentVNode("", true),
    (_unref(userGroups).includes('1') || [5735, 330].includes(_unref(user_id)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(GuangFa)
        ]))
      : _createCommentVNode("", true),
    (_unref(userGroups).includes('1') || _unref(userGroups).includes('18') || _unref(user_id) == 6717)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(DelayOrder)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(BindCard)
    ]),
    _createElementVNode("div", null, [
      _createVNode(StoreInfo)
    ]),
    _createElementVNode("div", null, [
      _createVNode(MerchandiseInfo)
    ]),
    _createElementVNode("div", null, [
      _createVNode(CouponInfo)
    ]),
    _createElementVNode("div", null, [
      _createVNode(ExportByNumOrMoney)
    ]),
    _createElementVNode("div", null, [
      _createVNode(TrackingPointsData)
    ]),
    _createElementVNode("div", null, [
      _createVNode(OrderTotalData)
    ]),
    _createElementVNode("div", null, [
      _createVNode(OrderReport)
    ]),
    _createElementVNode("div", null, [
      _createVNode(QixinOrder)
    ]),
    _createElementVNode("div", null, [
      _createVNode(HailiOrder)
    ]),
    _createElementVNode("div", null, [
      _createVNode(BaoPinData)
    ]),
    _createElementVNode("div", null, [
      _createVNode(SummaryBottom)
    ])
  ]))
}
}

})